export const PIPELINE_FILTER_DEFAULTS = {
  query: '',
  procedure_id: '',
  source_type: '',
  owner_id: '',
  inbox_id: '',
  message_origin: '',
  next_action_status: '',
  status: 'all',
};

export const PIPELINE_FILTER_KEYS = Object.keys(PIPELINE_FILTER_DEFAULTS);

export const filtersFromQuery = query =>
  Object.fromEntries(
    PIPELINE_FILTER_KEYS.map(key => [
      key,
      String(query[key] ?? PIPELINE_FILTER_DEFAULTS[key]),
    ])
  );

export const filtersToQuery = (filters, currentQuery = {}) => {
  const nextQuery = Object.fromEntries(
    Object.entries(currentQuery).filter(
      ([key]) => !PIPELINE_FILTER_KEYS.includes(key)
    )
  );

  Object.entries(filters).forEach(([key, value]) => {
    if (
      value !== '' &&
      value !== null &&
      value !== PIPELINE_FILTER_DEFAULTS[key]
    ) {
      nextQuery[key] = String(value);
    }
  });

  return nextQuery;
};

export const filterQuerySignature = query =>
  PIPELINE_FILTER_KEYS.map(key => String(query[key] ?? '')).join('|');

export const resolvePipelineView = view => (view === 'list' ? 'list' : 'board');

// `datetime-local` inputs speak wall-clock time with no zone, so the stored
// UTC instant has to be shifted into the viewer's zone before it is displayed
// or the field shows a time nobody scheduled.
export const toDatetimeLocal = value => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - timezoneOffset).toISOString().slice(0, 16);
};

export const createLatestRequestGuard = () => {
  let latestRequestId = 0;

  return {
    next: () => {
      latestRequestId += 1;
      return latestRequestId;
    },
    isCurrent: requestId => requestId === latestRequestId,
  };
};

export const opportunityConversationRoute = (opportunity, accountId) => {
  const conversationId = opportunity?.conversation?.id;
  if (!conversationId || !accountId) return null;

  return {
    name: 'inbox_conversation',
    params: {
      accountId,
      conversation_id: conversationId,
    },
  };
};

export const isOpportunityOverdue = (opportunity, now = new Date()) => {
  if (!opportunity?.nextActionAt) return false;
  return new Date(opportunity.nextActionAt).getTime() < now.getTime();
};
